<template>
  <setting-layout
    header-title="增加额度"
    footer-text="立刻兑换"
    :loading="loading"
    @footer-click="redeemQuota"
    class="token-manage-layout"
  >
    <el-form
      label-width="120px"
      class="quota-form"
    >
      <el-form-item label="当前可用额度">
        <span :class="{ 'negative-quota': availableTokens < 0 }">{{ availableTokens }} 个令牌</span>
      </el-form-item>
      <el-form-item label="已使用额度">
        <span>{{ usedQuota }} 个令牌</span>
      </el-form-item>
      <el-form-item
        class="quota-form-item"
        label="额度密钥"
      >
        <el-input
          v-model="quotaKey"
          placeholder="请输入额度密钥或点击右侧按钮导入文件"
          style="width: calc(100% - 100px); margin-right: 10px;"
        />
        <el-upload
          action=""
          :show-file-list="false"
          :before-upload="handleBeforeUpload"
          :http-request="handleHttpRequest"
          style="display: inline-block;"
        >
          <el-button type="primary">导入文件</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="历史记录">
        <router-link
          type="primary"
          :to="{ name: 'TokenHistory' }"
          :underline="false"
        >查看历史记录</router-link>
      </el-form-item>
    </el-form>
    <el-dialog
      title="激活成功"
      :visible.sync="visible"
      :close-on-click-modal="false"
      width="30%"
      center
    >
      <p style="font-size: 16px; text-align: center;">激活成功，当前可用额度：{{ availableTokens }}个令牌。</p>
      <p style="font-size: 14px; text-align: center;">如有异常，请第一时间联系技术支持。</p>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="visible = false"
        >确 定</el-button>
      </span>
    </el-dialog>
  </setting-layout>
</template>

<script>
import SettingLayout from '@/components/setting-layout.vue';
import { getUsedTokens, tokenImport } from '@/api/base';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'IncreaseQuota',
  components: {
    SettingLayout,
  },
  data() {
    return {
      usedQuota: 0, // Example data, kept as string for formatting
      quotaKey: '',
      loading: false,
      visible: false,
    };
  },
  computed: {
    ...mapGetters('user', ['availableTokens']),
  },
  methods: {
    ...mapActions('user', ['updateAvailableTokens']),
    getAvailableTokens() {
      return this.updateAvailableTokens();
    },
    getUsedTokens() {
      return getUsedTokens().then((res) => {
        this.usedQuota = res.usedTokens;
      });
    },
    handleBeforeUpload(file) {
      console.log(file);
      const isLicenseFile = file.name === 'license';
      if (!isLicenseFile) {
        this.$message.error('只能上传名为 "license" 的文件!');
      }
      return isLicenseFile;
    },
    handleHttpRequest(options) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.quotaKey = e.target.result;
      };
      reader.readAsText(options.file);
      return Promise.resolve(); // Prevent el-upload from making its own xhr request
    },
    tokenImport() {
      this.loading = true;
      tokenImport({
        content: this.quotaKey,
      })
        .then(() => {
          this.getAvailableTokens().then(() => {
            this.quotaKey = '';
            this.visible = true;
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    redeemQuota() {
      if (!this.quotaKey) {
        this.$message.error('请输入额度密钥');
        return;
      }

      this.tokenImport();
    },
  },
  mounted() {
    this.getAvailableTokens();
    this.getUsedTokens();
  },
};
</script>

<style lang="scss">
.token-manage-layout {
  .quota-form {
    max-width: 800px;
    margin: 0 auto;
  }

  .quota-form .el-form-item {
    margin-bottom: 22px;
  }

  .quota-form .el-form-item__label {
    font-weight: bold;
    color: #606266;
    text-align: left;
  }

  .negative-quota {
    color: red;
    font-weight: bold;
  }

  /* .redeem-button-container and .redeem-button styles can be removed */

  /* Ensure Element UI components are styled correctly if needed */
  .el-input__inner {
    border-radius: 4px;
  }

  .el-link {
    font-size: 14px;
  }

  .quota-form-item .el-form-item__content {
    display: flex;
    align-items: center;
  }
}
</style>
